import React, { Fragment } from 'react';
import moment from 'moment';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { Button, Paper, Grid, TextField, Tooltip, InputAdornment, FormControl, FormLabel, FormControlLabel, FormGroup, Checkbox, RadioGroup, Radio } from '@material-ui/core';
import { fieldDateFormat, backendDateFormat } from '../../../constants';
import { checkUserTypeFn, permissionCheckFn } from '../../../utils';
import { regexConstants } from '../../../constants/regEx';
const ApuEvent = ({error, item, onFieldChange, updateErrorField, crudData, mode, permissionFlag}) => {
  return(
    <Fragment>
      <Grid item md={4} xs={12}>
        <TextField
          id="hours_at_lsv"
          label='Hours @ LSV'
          fullWidth
          margin="normal"
          disabled={mode === 'view' || !permissionFlag? true:false}
          inputProps={{ maxLength: 10 }}
          InputLabelProps={{ shrink: true }}
          value={item.hours_at_lsv?item.hours_at_lsv:''}
          onChange={(e) => { regexConstants.numberWithDot.test(e.target.value) ? onFieldChange(e, 'hours_at_lsv', e.target.value,'apu'): e.preventDefault()}}
          error={error?.hours_at_lsv ? true : false}
          helperText={error?.hours_at_lsv ? error?.hours_at_lsv : ''}
          onFocus={() => updateErrorField('hours_at_lsv', '')}
          InputProps={{
            endAdornment: <InputAdornment position="end">APU H</InputAdornment>,
          }}
          variant="outlined"
        />
      </Grid>
      <Grid item md={4} xs={12}>
        <TextField
          id="cycles_at_lsv"
          label='Cycles @ LSV'
          fullWidth
          margin="normal"
          disabled={mode === 'view' || !permissionFlag? true:false}
          inputProps={{ maxLength: 10 }}
          InputLabelProps={{ shrink: true }}
          value={item.cycles_at_lsv?item.cycles_at_lsv:''}
          onChange={(e) => { regexConstants.numberWithDot.test(e.target.value) ? onFieldChange(e, 'cycles_at_lsv', e.target.value, 'apu'): e.preventDefault()}}
          error={error?.cycles_at_lsv ? true : false}
          helperText={error?.cycles_at_lsv ? error?.cycles_at_lsv : ''}
          onFocus={() => updateErrorField('cycles_at_lsv', '')}
          InputProps={{
            endAdornment: <InputAdornment position="end">APU C</InputAdornment>,
          }}
          variant="outlined"
        />
      </Grid>
      <Grid item md={4} xs={12}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <KeyboardDatePicker
            required
            disabled={mode === 'view' || !permissionFlag? true:false}
            margin="normal"
            id="lsv_date"
            label="LSV Date"
            placeholder="DD-MM-YYYY"
            format={fieldDateFormat}
            fullWidth
            disableFuture={true}
            InputLabelProps={{ shrink: true }}
            minDate={moment().subtract(25, 'years')}
            onChange={(data, value) => onFieldChange(value, 'lsv_date', data ? moment(data).format(backendDateFormat) : data, 'apu')}
            value={item.lsv_date?item.lsv_date:null}
            error={error?.lsv_date ? true : false}
            helperText={error?.lsv_date ? error?.lsv_date : ''}
            onFocus={() => updateErrorField('lsv_date', '')}
            inputVariant="outlined"
          />
        </MuiPickersUtilsProvider>
      </Grid>
      { checkUserTypeFn() && permissionCheckFn({secondaryKey:'hthl', keyIndex:'OV'}) ?
        <Fragment>
          <Grid item md={4} xs={12}>
            <TextField
              required
              id="interval_fh"
              label='Interval'
              fullWidth
              margin="normal"
              disabled={mode === 'view' || !permissionFlag? true:false}
              inputProps={{ maxLength: 10 }}
              InputLabelProps={{ shrink: true }}
              value={item.interval_fh?item.interval_fh:''}
              onChange={(e) => {regexConstants.numberWithDot.test(e.target.value) ? onFieldChange(e, 'interval_fh', e.target.value, 'apu'): e.preventDefault()}}
              error={error?.interval_fh ? true : false}
              helperText={error?.interval_fh ? error?.interval_fh : ''}
              onFocus={() => updateErrorField('interval_fh', '')}
              InputProps={{
                endAdornment: <InputAdornment position="end">APU H</InputAdornment>,
              }}
              variant="outlined"
            />
          </Grid>
          <Grid item md={4} xs={12}>
            <TextField
              id="cost"
              label='Cost'
              fullWidth
              margin="normal"
              disabled={mode === 'view' || !permissionFlag? true:false}
              inputProps={{ maxLength: 10 }}
              InputLabelProps={{ shrink: true }}
              value={item.cost?item.cost:''}
              onChange={(e) => {regexConstants.numberWithDot.test(e.target.value) ? onFieldChange(e, 'cost', e.target.value, 'apu'): e.preventDefault()}}
              error={error?.cost ? true : false}
              helperText={error?.cost ? error?.cost : ''}
              onFocus={() => updateErrorField('cost', '')}
              InputProps={{
                startAdornment: <InputAdornment position="start">$</InputAdornment>,
              }}
              variant="outlined"
            />
          </Grid>
          <Grid item md={4} xs={12}>
            <TextField
              id="remarks"
              label='Remarks'
              fullWidth
              margin="normal"
              disabled={mode === 'view' || !permissionFlag? true:false}
              inputProps={{ maxLength: 250 }}
              InputLabelProps={{ shrink: true }}
              value={item.remarks?item.remarks:''}
              onChange={(e) => onFieldChange(e, 'remarks', e.target.value, 'apu')}
              error={error?.remarks ? true : false}
              helperText={error?.remarks ? error?.remarks : ''}
              onFocus={() => updateErrorField('remarks', '')}
              variant="outlined"
              multiline={true}
            />
          </Grid>
        </Fragment>:null
      }
    </Fragment>
  )
}
export default ApuEvent;
